import React, { useContext, useEffect, useState, useRef } from 'react';
import {useSelector} from "react-redux";
import PropTypes from "prop-types";

import FormRow from "../../../../Components/HorizontalForm/FormRow";
import {ucfirst} from "../../../../Helpers/StringHelper";
import ResourceSelector from "../../../../Components/Inputs/Selects/ResourceSelector";
import UserSelector from "../../../../Components/Inputs/Selects/UserSelector";
import { BOOKINGS_API_URL } from "../../Bookings";
import BookingFormUserSectionDisabled from "./BookingFormUserSectionDisabled";
import UnitSelectorForConfigurableEntity from "../../../../Components/Inputs/Selects/UnitSelectorForConfigurableEntity";
import { BookingFormContext } from "../BookingFormProvider";

const BookingFormUserSection = () => {

    const {
        currentUser,
        canChangeOtherUsers,
        hasMultipleUnits,
        category,

        booking,
        errors,

        onBookingFormChange,
        onBookingFormChangeMultiple,
        onBookingFormChangeEvent,

        editBookingId
    } = useContext(BookingFormContext);

    const siteTypeLabel = useSelector(state => state.global.siteTypeLabel);

    const [unitName, setUnitName] = useState('');

    /**
     * If user can only add bookings for themselves, pre-populate with current logged in user
     */
    useEffect(() => {
        if (!canChangeOtherUsers && !!editBookingId) {
            onBookingFormChangeMultiple({
                user_id: currentUser.id,
                user_name: currentUser.fullname,
                email: currentUser.email,
                contact: currentUser.mobile ?? currentUser.telephone
            })
        }
    }, [canChangeOtherUsers])


    /**
     * Retrieve unit data just so we can display the unit name in a text field....
     */
    useEffect(() => {
        axios.get(`${BOOKINGS_API_URL}universal/units/${booking.unit_id}`)
            .then(response => {
                const unitData = response.data.data.unit;
                setUnitName(unitData.name);
            });

    }, [booking?.unit_id])

    if (!!editBookingId) {
        return <BookingFormUserSectionDisabled />
    }

    return (
        <section className="section form-container full margin-bottom-0">

            { (canChangeOtherUsers) && (
                <FormRow
                    label="Full Name"
                    errorMessage={errors.user_id}
                    required
                >
                    <UserSelector
                        name={'user_id'}
                        module={'bookings'}
                        entity={category.id}
                        value={booking.user_id}
                        onChange={(name, value) => onBookingFormChangeMultiple({user_id: value})}
                        disabled={(!canChangeOtherUsers)}
                    />
                </FormRow>
            )}

            { (hasMultipleUnits) && (
                <FormRow
                    label={ucfirst(siteTypeLabel)}
                >
                    <input
                        type="text"
                        name="unit_name"
                        value={unitName}
                        disabled
                    />
                </FormRow>
            )}

        </section>
    );
}

BookingFormUserSection.propTypes = {
}

export default BookingFormUserSection;
